import { api } from "@/api/api"
import { isAxiosError } from "axios"

export const getBannersAction = async(formData) => {
  try {
    const { data } = await api.post(`/ajax/ajax.banners.php`, formData)

    return data
  } catch (error) {
    if (isAxiosError(error)) {
      return {
          estado: 'error',
          mensaje: error.response.data.mensaje,
          banners: []
      }
    }

    console.log(error)
    throw new Error('Error')
  }
}